import axios from "../axios-auth";
import orginal_axios from "axios";

export const purchaseOrderService = {
  getPurchaseOrderList,
  savePurchaseOrderAsset,
  savePurchaseOrder,
  getPurchaseOrderDetail,
  getAllPurchaseOrderList,
  exportPurchaseOrderExcel,
  printPOInvoice,
  showWindowDialog,
  saveOrderPO,
  getPOStockReport,
  getAllPOStockReport,
  getPurchaseAnalysisListBySupplier,
  getPurchaseOrderExcelTemplate,
  savePurchaseOrderExcel,
  savePurchaseOrderAssetExcel,
  saveFiles,
  downloadFile,
  getAllPurchaseOrderStatus,
  getAllPurchaseTypes,
  getPoItemDetailList,
  getAllPurchaseType,
};

function exportPurchaseOrderExcel(searchParams) {
  let params = {
    sort: "warehouseName,asc"
  };
  if (searchParams.fromIssueDate) {
    params["fromIssueDate"] = searchParams.fromIssueDate;
  }
  if (searchParams.toIssueDate) {
    params["toIssueDate"] = searchParams.toIssueDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.procurementPlanNo) {
    params["procurementPlanNo"] = searchParams.procurementPlanNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }
  if (searchParams.isStockInRegisterFlag) {
    params["isStockInRegisterFlag"] = searchParams.isStockInRegisterFlag;
  }
  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }
  if (searchParams.purchaseOrderType) {
    params["purchaseOrderType"] = searchParams.purchaseOrderType;
  }
  if (searchParams.orderYear) {
    params["orderYear"] = searchParams.orderYear;
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/purchase-order/purchase-order-excel",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}
function getAllPurchaseOrderList(searchParams) {
  let params = {
    sort: "warehouseName,asc"
  };
  if (searchParams.fromIssueDate) {
    params["fromIssueDate"] = searchParams.fromIssueDate;
  }
  if (searchParams.toIssueDate) {
    params["toIssueDate"] = searchParams.toIssueDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.isStockInRegisterFlag) {
    params["isStockInRegisterFlag"] = searchParams.isStockInRegisterFlag;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }

  return axios.get("/auth/purchase-order", { params });
}

function getPurchaseAnalysisListBySupplier(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.fromIssueDate) {
    params["fromIssueDate"] = searchParams.fromIssueDate;
  }
  if (searchParams.toIssueDate) {
    params["toIssueDate"] = searchParams.toIssueDate;
  }
  if (searchParams.companyName) {
    params["companyName"] = searchParams.companyName;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.type) {
    params["type"] = searchParams.type;
  }
  return axios.get("/auth/purchase-order/purchase-analysis-report-by-supplier", { params });
}

function getPurchaseOrderList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.fromIssueDate) {
    params["fromIssueDate"] = searchParams.fromIssueDate;
  }
  if (searchParams.toIssueDate) {
    params["toIssueDate"] = searchParams.toIssueDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }
  if (searchParams.isStockInRegisterFlag) {
    params["isStockInRegisterFlag"] = searchParams.isStockInRegisterFlag;
  }
  if (searchParams.isPOFinishedFlag) {
    params["isPOFinishedFlag"] = searchParams.isPOFinishedFlag;
  }
  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }
  if (searchParams.statuses) {
    params["statuses"] = searchParams.statuses.join();
  }
  if (typeof searchParams.checkQc == 'boolean') {
    params["checkQc"] = searchParams.checkQc;
  }
  if (typeof searchParams.checkStockIn == 'boolean') {
    params["checkStockIn"] = searchParams.checkStockIn;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (typeof searchParams.checkUnpaid == 'boolean') {
    params["checkUnpaid"] = searchParams.checkUnpaid;
  }
  if (searchParams.purchaseType) {
    params["purchaseType"] = searchParams.purchaseType;
  }
  if (searchParams.procurementPlanNo) {
    params["procurementPlanNo"] = searchParams.procurementPlanNo;
  }
  if (searchParams.orderYear) {
    params["orderYear"] = searchParams.orderYear;
  }
  if (searchParams.purchaseOrderType) {
    params["purchaseOrderType"] = searchParams.purchaseOrderType;
  }

  return axios.get("/auth/purchase-order", { params });
}

function savePurchaseOrder(purchaseOrder) {
  if (!purchaseOrder.id) {
    // new purchase order
    return axios.post("/auth/purchase-order", purchaseOrder);
  } else {
    // edit
    return axios.put("/auth/purchase-order", purchaseOrder);
  }
}

function savePurchaseOrderAsset(purchaseOrder) {
  if (!purchaseOrder.id) {
    // new purchase order
    return axios.post("/auth/purchase-order/purchase-order-asset", purchaseOrder);
  } else {
    // edit
    return axios.put("/auth/purchase-order/purchase-order-asset", purchaseOrder);
  }
}

function getPurchaseOrderDetail(id) {
  return axios.get("/auth/purchase-order/" + id);
}

function printPOInvoice(id) {
  return orginal_axios({
    url: axios.defaults.baseURL + "/auth/purchase-order/invoice/" + id,
    method: "GET",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/pdf",
      "Content-Type": "application/json"
    }
  }).then(function (response) {
    return new Blob([response.data], { type: "application/pdf" });
  });
}

function showWindowDialog(blob, fileName) {
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob);
    return;
  }
  // For other browsers: 
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob);
  var link = document.createElement(fileName);
  link.href = data;
  link.download = fileName + ".pdf";
  window.open(link.href, fileName, "width=500,height=500");

  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
}

function saveOrderPO(orderPO) {
  return axios.post("/auth/purchase-order/order-po", orderPO);
}

function getPOStockReport(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  }
  else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.warehouseIds) {
    params["warehouseIds"] = searchParams.warehouseIds.join();
  }
  if (searchParams.productIds) {
    params["productIds"] = searchParams.productIds.join();
  }
  if (searchParams.categoryIds) {
    params["categoryIds"] = searchParams.categoryIds.join();
  }

  return axios.get("/auth/purchase-order/po-stock-report", { params });
}

function getAllPOStockReport(searchParams) {
  let params = {};

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.warehouseIds) {
    params["warehouseIds"] = searchParams.warehouseIds.join();
  }
  if (searchParams.productIds) {
    params["productIds"] = searchParams.productIds.join();
  }
  if (searchParams.categoryIds) {
    params["categoryIds"] = searchParams.categoryIds.join();
  }

  return axios.get("/auth/purchase-order/po-stock-report-print", { params });
}

function getPurchaseOrderExcelTemplate(searchParams) {
  let params = {};

  if (searchParams.brandName) {
    params["brandName"] = searchParams.brandName;
  }

  if (searchParams.categoryName) {
    params["categoryName"] = searchParams.categoryName;
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/purchase-order/purchaseorder-excel-template",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function savePurchaseOrderExcel(file) {
  return axios.post('/auth/purchase-order/purchaseorder-excel',
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

function savePurchaseOrderAssetExcel(file) {
  return axios.post('/auth/purchase-order/purchase-order-asset-excel',
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

function saveFiles(files, id) {
  return axios.post('/auth/purchase-order/files/' + id, files, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

function downloadFile(id) {
  return axios.get("/auth/purchase-order/downloadFile/" + id, { responseType: "blob" });
}

function getAllPurchaseOrderStatus() {
  return axios.get("/auth/purchase-order/all-purchase-order-status");
}

function getAllPurchaseTypes(purchaseOrderType) {
  return axios.get("/auth/purchase-order/all-purchase-types/" + purchaseOrderType);
}

function getPoItemDetailList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.poItemId) {
    params["poItemId"] = searchParams.poItemId;
  }

  return axios.get("/auth/purchase-order/po-item-details", { params });
}
function getAllPurchaseType() {
  return axios.get("/auth/purchase-order/all-purchase-type");
}

